import React from 'react';

import propTypes from 'prop-types';
import accountPropTypes from 'apps/account/propTypes';
import Button from 'components/Button';
import AddMultipleOfferingsToCartButton from 'containers/AddMultipleOfferingsToCartButton';
import { TranslatedMessage } from 'common/components/Intl';

const SubscriptionCommitModalFooter = ({
  onClose,
  offering,
  variantName,
  dismissTranslationId,
  acceptTranslationId,
}) => (
  <div className="SubscriptionCommitModalFooter button-group">
    <Button
      className="button--outline SubscriptionCommitModalFooter__button SubscriptionCommitModalFooter__button--dismiss"
      onClick={onClose}
    >
      <TranslatedMessage id={dismissTranslationId} />
    </Button>
    <AddMultipleOfferingsToCartButton
      className="button--vivid SubscriptionCommitModalFooter__button SubscriptionCommitModalFooter__button--accept"
      offerings={[offering]}
      onClick={onClose}
    >
      <TranslatedMessage id={acceptTranslationId} values={{ variantName }} />
    </AddMultipleOfferingsToCartButton>
  </div>
);

SubscriptionCommitModalFooter.propTypes = {
  onClose: propTypes.func.isRequired,
  offering: accountPropTypes.VariantOffering.isRequired,
  dismissTranslationId: propTypes.string.isRequired,
  acceptTranslationId: propTypes.string.isRequired,
  variantName: propTypes.string,
};

export default SubscriptionCommitModalFooter;
